import { DocsRetrieveResponse } from '../../openapi/operations/docsRetrieve';
import { DocHistoryResponse, NestedSubjektResponse } from '../../openapi/types';
import { PrejimkaTypesEnum } from '../../openapi/types/PrejimkaTypesEnum';
import { DOCUMENTATION_TYPES, DATA_ORIGIN_TYPES, DOC_STATE } from '../constants';

export const defaultValues: DocsRetrieveResponse = {
  url: '',
  handover_protocol: '',
  id: NaN,
  author: { name: '', surname: '' } as any,
  receiver: { name: '', surname: '' } as any,
  creator: { name: '', surname: '' } as any,
  cadasters: [],
  editor_manager: null,
  responsible_person: null,
  geodesist: { name: '', surname: '' } as any,
  attachments: [],
  utilities_type: '',
  download_attachments_link: '',
  created: undefined as any,
  accepted: undefined as any,
  attachments_count: 0 as any,
  name: '',
  data_origin: DATA_ORIGIN_TYPES.GEODETIC_SURVEYING,
  documentation_type: DOCUMENTATION_TYPES.DSPS,
  geometry_plan_number: '',
  has_planimetry: false,
  has_utilities: false,
  note: '',
  description: '',
  rejection_reason: undefined,
  rejection_note: '',
  state: DOC_STATE.INPROGRESS,
  owner_street: '',
  owner_city: '',
  owner_postal_code: '',
  owner_name: '',
  owner_ico: '',
  owner_birth_number: '',
  processor_street: '',
  processor_city: '',
  processor_postal_code: '',
  processor_name: '',
  processor_ico: '',
  processor_birth_number: '',
  location: '',
  edited: '',
  checks: [],
  prejimka_type: PrejimkaTypesEnum.DTM,
  rozsah_aktualizacni_zmeny_extent: [],
  subjekt: {
    adresa: '',
    id_subjektu: '',
    jmeno: '',
    url: '',
  } as NestedSubjektResponse,
  dmvs_rozsahy: [],
  editor_subjekt: {
    adresa: '',
    id_subjektu: '',
    jmeno: '',
  } as NestedSubjektResponse,
  failed_call: null,
  history: [] as DocHistoryResponse[],
  azi_cislo_opravneni: NaN,
  svu_cross_names: [],
  rejected_by_subjekty: [],
};
